import T from 'prop-types'
import React from 'react'
import ListInput from './ListInput'
import {
  validateIP,
  validateCIDR,
  validateIPorCIDR
} from 'pw-validators'

export default class extends React.Component {
  static displayName = 'IpListInput'

  static propTypes = {
    className: T.string,
    initialValue: T.string,
    onChange: T.func,
    allowCIDR: T.bool,
    allowIP: T.bool,
    allowDuplicates: T.bool,
    typeaheadOptions: T.arrayOf(T.string)
  }

  static defaultProps = {
    allowCIDR: true,
    allowIP: true
  }

  resetToInitialValue = () => {
    if (this._editor) {
      this._editor.resetToInitialValue()
    }
  }

  _handleEditorRef = (inst) => {
    this._editor = inst
  }

  render() {
    const {
      allowCIDR,
      allowIP
    } = this.props

    let validator = null
    let placeholder = ``

    if (allowCIDR && allowIP) {
      validator = validateIPorCIDR
      placeholder = `192.168.0.1 ... ff::/64`
    } else if (allowCIDR) {
      validator = validateCIDR
      placeholder = `192.168.0.1/16`
    } else if (allowIP) {
      validator = validateIP
      placeholder = `10.10.0.0`
    }

    return (
      <ListInput
        lineClassName={ `ip_list_item` }
        lineLabel={ "IP" }
        lineValidator={ validator }
        placeholder={ placeholder}
        ref={ this._handleEditorRef }
        { ...this.props }
      />
    )
  }
}
